import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as svc from './services'
import { Logged } from './models/logged';
import { WebService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  isLogin; // boolean variable to check if user is login or not
  partnerDetail: any;
  connectionEstablished: boolean;
  options = {
    position: ['top', 'right'],
    timeOut: 1000,
    lastOnBottom: true
  };
  hamburger;
  sideMenu;
  content;
  isMobileVersion;
  errorCount = 0;
  private logged: Logged;
  constructor(
    private notificationService: svc.NotificationService,

    private ls: svc.LoggedService,
    private _commonRequestResponseService: svc.CommonRequestResponseService,
    private _commonAuthenticationService: svc.CommonAuthenticationService,
    private routeDataService: svc.RouteDataService,
    private router: Router, private routes: ActivatedRoute,
    private commonDataSharedService: svc.CommonDataSharedService,
    private _commonService: svc.CommonService,
    private title: Title,
    private webService: WebService,
    @Inject(DOCUMENT) private _document: HTMLDocument
  ) {
    document.addEventListener('click', this.offClickHandler.bind(this));
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.split('?')[0] === '/register') {
          this.isLogin = false;
          this._commonAuthenticationService.clearLoginInfo();
        }
      }
    });
  }

  offClickHandler(event: any) {
    this.isMobileVersion = this._commonService.checkDeviceIsMobile();
    if (this.hamburger && !this.hamburger.contains(event.target) && this.sideMenu && this.sideMenu.nativeElement && this.isMobileVersion) {
      this.sideMenu.nativeElement.classList.remove('show');
      this.content.nativeElement.classList.add('closed');
      document.querySelector('.hamburger').classList.remove('closeMenu');
    }
  }

  ngOnInit() {  
    this.commonDataSharedService.toggleSideMenu.subscribe((data: any) => {
      this.isMobileVersion = this._commonService.checkDeviceIsMobile();
      if (this.isMobileVersion) {
        // document.querySelector('.side_menu').classList.add('ns-navigation-collapsed');
      }
    });

    this.commonDataSharedService.hamburger.subscribe((data: any) => {
      this.hamburger = data;
    })
    this.commonDataSharedService.sidemenu.subscribe((data: any) => {
      this.sideMenu = data;
    });

    this.commonDataSharedService.content.subscribe((data: any) => {
      this.content = data;
    });

    this.commonDataSharedService.sessionExpired.subscribe((data: any) => {
      this._commonRequestResponseService.resetLoginDetail();
      this.errorCount = this.errorCount + 1;
      this.commonDataSharedService.partnerDetailData.next(this.partnerDetail);
      this._commonAuthenticationService.clearLoginInfo();
      this.isLogin = 'false';

      this.router.navigate(['./login'], { relativeTo: this.routes })
      if (this.errorCount === 1) {
        this._commonService.hideHelpMenuAndPopup();
        this.notificationService.show('error', 'Session expired');
      }
    });

    const localStorageData = this._commonAuthenticationService.getLoginData();
    this.isLogin = localStorage ? localStorage.isLogin : 'false';
    this.checkPartnerDetail(); // call check partner detail function

    if (!localStorageData || !localStorageData.isLogin) {
      this.ls.getLogged().subscribe(logged => {
        this.logged = logged;
        this.isLogin = 'true';
        // this.checkRegisterPage();
      });
    } else {
      this.isLogin = localStorageData.isLogin;
      this.logged = localStorageData as Logged;
    }

    this.setUpRouteSubscriptions();
  }

   setUpRouteSubscriptions() {

    this.routeDataService.setMainMenuChildRoute.subscribe((path: string) => {
      this.router.navigate([path], { relativeTo: this.routes })
    });

    this.routeDataService.logout.subscribe((data: any) => {
      this.commonDataSharedService.partnerDetailData.next(this.partnerDetail);
      this._commonAuthenticationService.clearLoginInfo();
      this.isLogin = 'false';
    });

    this.routeDataService.login.subscribe((data: any) => {
      this.isLogin = 'true';
    });

    this.routeDataService.unAuthorized.subscribe((data: any) => {
      this.notificationService.show('info', 'You’ve been logged out of your account. Please login again');
    });
  }

  /**
   *@ngdoc method
   *@name checkPartnerDetail
   *@methodOf app.component
   *@description
   * - This is a method, used to check partner detail
    */
  checkPartnerDetail() {
    let currentUrl; // variable to store current url
    let partnerUrlJson; // variable to store partner url json

    currentUrl = window.location.href.split('/')[2];

    partnerUrlJson = {
      sourceURL: currentUrl
    }; // variable to store partner url json
    this.getPartnerDetail(partnerUrlJson);
  }

  getPartnerDetail(partnerUrlJson) { 
    // JDO - 12.21.2017 - Offloaded service-level implementation to PartnerDetailService
    this._commonRequestResponseService.post('shared/partner/details', partnerUrlJson)
      .subscribe(
        (partnerData: any) => {
          this.partnerDetail = partnerData;
          // this.partnerDetail = null;
          const partnerName = this.partnerDetail.partnerName ? this.partnerDetail.partnerName : 'Envision';
          this.title.setTitle(partnerName);
          this.commonDataSharedService.partnerDetailData.next(this.partnerDetail);
          if (this.partnerDetail.favIconUrl) {
            this._document.getElementById('appFavicon').setAttribute('href', this.partnerDetail.favIconUrl);
          } else {
            this._document.getElementById('appFavicon').setAttribute('href', '/assets/img/favicons/favicon-16x16.png');
          }
          this._commonAuthenticationService.setPartnerDetailData(this.partnerDetail);
        },
        () => {
          if (localStorage.getItem('partnerDetail')) {
            localStorage.removeItem('partnerDetail');
          }
        });

    this.connectionEstablished = true;
  }
}
